import { useCallback } from 'react';
import { FocusClip } from './types';
import {
  useMessageDispatch,
  UseMessageDispatchProps,
} from './useEddyMessaging';

type UseClipHighlightMessagingProps = Pick<UseMessageDispatchProps, 'iframe'>;

export default function useClipHighlightMessaging({
  iframe,
}: UseClipHighlightMessagingProps) {
  const dispatch = useMessageDispatch({ iframe });

  const highlightClip: FocusClip = useCallback(
    clipTimesOrSuggestionId => {
      if (typeof clipTimesOrSuggestionId === 'number') {
        return undefined;
      }

      const { startMillis, endMillis } = clipTimesOrSuggestionId;

      dispatch({
        endMillis,
        type: 'clipHighlight',
        startMillis,
      });

      return undefined;
    },
    [dispatch],
  );

  return { highlightClip };
}
